<template>
    <router-link :to="{ path: '/items', query: { mapel: item.id } }" tag="li"
        ><a>{{ item.nama }}</a></router-link
    >
</template>

<script>
export default {
    name: "itembank-subnav",

    props: ["item"],
};
</script>



// WEBPACK FOOTER //
// SubNavigation.vue?0f5c488e